import React from 'react'
import { Flex, Box, Heading, Text, Button, Image } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { get } from 'lodash'

import { getDashboardCreateUserURL } from '../../utils/cta-utils'
import theme from '../../lib/theme'

const HeroSection = () => {
  const { t } = useTranslation('home')
  const images = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "home/hero_banner.png" }) {
        publicURL
      }
    }
  `)

  const hero = get(images, 'hero.publicURL')

  return (
    <Flex
      as="section"
      flexDirection={['column-reverse', 'column-reverse', 'row']}
      alignItems={['center', 'center', 'flex-start']}
      justifyContent={['center', 'center', 'flex-start']}
      maxWidth="container"
      width={1}
      mx="auto"
      pt={[10, 15, 10]}
      px={[5, 5, 0]}
      pb={[15, 15, 10]}
    >
      <Box
        maxWidth="482px"
        width={1}
        mt={[0, 0, 20]}
        mr={[0, 0, 14]}
        textAlign={['left', 'center', 'left']}
        sx={{
          '@media (max-width: 32rem)': {
            '& > a': {
              display: 'flex'
            }
          }
        }}
      >
        <Heading as="h1" variant="level1" fontSize={theme.customFontsize(42, 45)}>
          {t('title')}
        </Heading>

        <Text variant="level4" maxWidth="451px" width={1} mx={['auto', 0, 0]} mt={6} mb={8}>
          {t('subtitle')}
        </Text>

        <Link
          to={getDashboardCreateUserURL()}
          css={{
            '&:hover': {
              opacity: 1
            }
          }}
        >
          <Button variant="primary" width={['210px', '210px', '160px']} mx={['auto', 'auto', 0]}>
            {t('buttons.try_it_now')}
          </Button>
        </Link>
      </Box>

      <Box maxWidth="800px" width={1} mb={[5, 10, 0]}>
        <Image src={hero} />
      </Box>
    </Flex>
  )
}

export default HeroSection
